import {
  UpdateReviewTaskActions
} from "../../pages/applications/applicationDetail/tabs/dynamic/review/model/UpdateReviewTasks";

export const AlertMessage = {
  requestUserAccessData: {
    successMessage(applicationGitsProductTeamEmail) {
      return `Email has been sent to ${applicationGitsProductTeamEmail} successfully`;
    },
    errorMessage:
      "Failed to send request email, please contact with compliance-engineering-support@thoughtworks.com",
  },
  submitReview: {
    submittingSameRecordAfterReviewedByAnotherPerson: (
      <>
        The access changes for the highlighted users have already been submitted by other Access
        Owners, or some tasks are not delegated to you anymore.
        <br />
        You can continue to update the access for the remaining users.
      </>
    ),
    [UpdateReviewTaskActions.BatchSaveDecisionsRequest]: {
      success(count) {
        return (
            <>
              {count} review decisions have been saved, feel free to come back and start where you left off.
              <b>"Save for later"</b> is not the final submission, you will need to <b>"Preview and Submit"</b> to
              finalise the
              change.
            </>
        )
      },
    },
    [UpdateReviewTaskActions.BatchSubmitDecisionsRequest]: {
      success() {
        return "The changes you made have been successfully submitted. You can continue to review the rest."
      },
    },
    [UpdateReviewTaskActions.BatchTasksReassignmentRequest]: {
      success(count, payload) {
        if(count < 1) {
          return "All review task(s) are already delegated to the user";
        }
        return `Successfully reassigned ${count} review task(s) to the user`
      },
      error(count) {
        return `Failed to reassign ${count} review task(s) to the user. The task might've been already submitted / not delegated to you anymore`
      }
    },
    [UpdateReviewTaskActions.BatchClearDecisionsRequest]: {
      success() {
        return (
            <>
              The decision is successfully cleared for the selected task.
            </>
        )
      },
    }
  },
  downloadCSVReport: {
    errorMessage(reviewName) {
      return `Download failed for ${reviewName}`;
    },
    successMessage(reviewName) {
      return `Successfully downloaded ${reviewName}`;
    },
  },
  axiosErrors: {
    serverError:
      "Sorry, something went wrong. Please contact compliance-engineering-support@thoughtworks.com",
    timeoutError: "Network error : Request timed out",
    connectionRefused: "Network error : Connection refused / Internet is not available",
  },
  reAssignTask: {
    success:
      "Reassign Task Succeeded! The new assignee and the Global Access Approver(s) will be notified of the reassigned task.",
    error: "Reassign task failed!",
  },
  sendReminder: {
    success: "Successfully sent reminders to Global Access Approvers and Access Owners",
    error: "Failed to send reminders to Global Access Approvers and Access Owners",
  },
  previewBeforeStartReview: {
    error: "Failed to load preview data for starting review",
  },
  copyAllEmails: {
    applications: {
      GAA: "Emails of all Global access approvers are copied to clipboard",
      AO: "Emails of all Access owners are copied to clipboard",
    },
    userGroups: {
      users: (userGroupRepresentationName, userRoleName) =>
        `Emails of all ${userGroupRepresentationName} ${userRoleName} are copied to clipboard`,
    },
  },
};
